<mat-card class="mat-card mat-card--widget">
  <ecp-loader *ngIf="loading"></ecp-loader>
  <label for="file-upload" class="custom-file-upload">
    <span class="obligation__label">
      <mat-icon class="obligation__icon" aria-hidden="false">cloud_download</mat-icon>
      <span class="obligation__drop-label"><br />Drag & Drop file here</span>
      <span>or</span>

      <span class="obligation__file-value" *ngIf="selectedFile">
        {{ selectedFile.name }}
      </span>
      <button class="btn btn-outline mt-15">Browse Files</button>
    </span>

    <input
      [formControl]="file"
      id="file-upload"
      type="file"
      class="form-control"
      (change)="onFileChange($event)"
      required
    />
    <mat-error>
      <fa-icon icon="exclamation-triangle"></fa-icon>
      File is required.
    </mat-error>
  </label>
  <br />
  <button [disabled]="file.invalid" class="btn btn-primary" (click)="submitForValidation()" mat-button color="primary">
    Submit file for validation
  </button>
</mat-card>
